export const TaskContractAddress = "0xB8520d9CA60f7d8f9D97c94B20D3E17FBe7BF85A"
